import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

export interface CustomGetCategoriesApiParameter extends ApiParameter, HasPagingParameters {
    categoryId: string;
}

export interface CustomCategoryPropsModel {
    categoryShowImageOnPLP: string;
    contentTop: string;
    gridview: string;
    productListGridAttributeColumns: string;
}

const customCategoriesUrl = "api/v1/categoryproperties";

export async function getCustomCategoriesProps(parameter: CustomGetCategoriesApiParameter) {
    const categoryCollectionModel = await get<CustomCategoryPropsModel>(`${customCategoriesUrl}/`, parameter);

    return {
        categoryShowImageOnPLP: categoryCollectionModel.categoryShowImageOnPLP === "true",
        gridview: categoryCollectionModel.gridview === "true",
        productListGridAttributeColumns: categoryCollectionModel.productListGridAttributeColumns,
        contentTop: categoryCollectionModel.contentTop,
    };
}
